<template>
  <div class="sm-facets">

    <transition
        name="custom-classes-transition"
        enter-active-class="animated faster slideInUp"
        vleave-active-class="animated faster slideOutDown"
    >
      <div v-if="isOpenFacets" class="sm-screen" key="sm-screen">
        <div class="sm-screen__actions sm-screen__actions_top">
          <div class="sm-screen__slot sm-screen__slot_l">
            <button @click="clearAllFacets" :disabled="filtersCount === 0" class="sm-screen__button sm-screen__button_f-small">
              Очистить все
            </button>
          </div>
          <div class="sm-screen__slot"><span class="sm-screen__title">Фильтры</span></div>
          <div class="sm-screen__slot sm-screen__slot_r">
            <button @click="toggleOpenFacets" class="sm-screen__button sm-screen__button_f-small">
              Закрыть
            </button>
          </div>
        </div>

        <div class="sm-screen__content sm-screen__content_indented">

          <FacetSlider></FacetSlider>
          <FacetCategoriesMobile></FacetCategoriesMobile>

          <Facets @filterchanged="onFilterChanged"></Facets>
        </div>

        <div class="sm-screen__actions sm-screen__actions_bottom">
          <button @click="toggleOpenFacets" class="sm-screen__button sm-screen__button_stretch">
            Показать {{ getTotal() }}
          </button>
        </div>

      </div>
    </transition>
      <div v-if="!isOpenFacets && !showSortMobile" class="sm-screen__actions sm-screen__actions_fixed sm-screen__actions_bottom">
        <button @click="setShowSortMobile(true)" class="sm-screen__button sm-screen__button_stretch">
          <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" class="sm-screen__icon sm-search-form__icon_specific">
            <use xlink:href="#sort"></use>
          </svg>
          Сортировка
        </button>
        <button @click="toggleOpenFacets" class="sm-screen__button sm-screen__button_stretch">
          <span v-if="filtersCount > 0" class="sm-screen__count">{{ filtersCount }}</span>
          <svg v-else width="16" height="13" viewBox="0 0 16 13" xmlns="http://www.w3.org/2000/svg" class="sm-screen__icon sm-search-form__icon_specific">
            <use xlink:href="#filters"></use>
          </svg>
          Фильтры
        </button>
      </div>


    <sm-sort-mobile v-if="showSortMobile"></sm-sort-mobile>

  </div>
</template>

<script>
import FacetCategoriesMobile from './facet-categories-mobile.vue';
import FacetSlider from './facet-slider.vue';
import Facets from './facets.vue';
import SmSortMobile from '../sm-sort-mobile.vue';
import helpers from "../../store/helpers";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "facets-container",
  computed: {
    ...mapGetters("search", [
      "isOpenFacets",
      "totalHits",
      "queryFilters",
      "showSortMobile",
      "selected_category"
    ]),
    filtersCount() {
      let ret = this.queryFilters.length;
      if(this.selected_category > 0) {
        ret++;
      }
      return ret;
    }
  },
  methods: {
    ...mapActions("search", ["toggleOpenFacets", "doSearch", "resetFilters", "setShowSortMobile"]),
    onFilterChanged: function () {
      if(this.$refs.InfiniteLoading){
        // сброс состояния компоненты infinite-loading
        this.$refs.InfiniteLoading.stateChanger.reset();
      }
    },
    clearAllFacets: function () {
      this.resetFilters()
      this.doSearch().then(() => {}).catch(err => {
        console.log(err.response.statusText)
      })
    },
    getTotal: function () {
      return this.totalHits + ' ' + helpers.getCorrectPlural('товар', this.totalHits);
    },
  },
  components: {
    FacetCategoriesMobile,
    FacetSlider,
    Facets,
    SmSortMobile
  }
}
</script>